import React from "react";
import PropTypes from "prop-types";
import StandardMoney from "../../common/StandardMoney";

const Record = ({ intl, transactionType, actualAmount, currency }) => {
  return (
    <tr>
      <td>
        {intl.formatMessage({
          id: transactionType,
          defaultMessage: transactionType,
        })}
      </td>

      <td className="field__currency">
        <StandardMoney value={actualAmount} currency={currency} />
      </td>
    </tr>
  );
};

Record.propTypes = {
  intl: PropTypes.object.isRequired,
  transactionType: PropTypes.string,
  actualAmount: PropTypes.number,
  currency: PropTypes.string,
};

export default Record;



// WEBPACK FOOTER //
// ./components/claim/widgets/Record.jsx